<template>
  <v-dialog
    v-model="show"
    max-width="1200"
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1">
            Koppel andere kaarten
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <div class="pa-5 ma-0">
        <v-row class="ma-0">
          <v-col md="8" cols="12">
            <div v-if="cards.length > 0">
              <v-list>
                <!--                <v-list-item-->
                <!--                  class="pa-0"-->
                <!--                  @click=""-->
                <!--                  v-for="(item, index) in cards"-->
                <!--                >-->
                <!--                  <v-row>-->
                <!--                    <v-col cols="6" sm="" class="align-self-center">{{-->
                <!--                      item.name-->
                <!--                    }}</v-col>-->
                <!--                    <v-col cols="6" sm="" class="align-self-center">{{-->
                <!--                      item.barcode-->
                <!--                    }}</v-col>-->
                <!--                    <v-col cols="auto">-->
                <!--                      <v-btn color="primary" @click="deleteCard(index)"-->
                <!--                        >Verwijder</v-btn-->
                <!--                      >-->
                <!--                    </v-col>-->
                <!--                  </v-row>-->
                <!--                </v-list-item>-->
              </v-list>

              <v-divider></v-divider>
            </div>
            <v-form ref="addcardform">
              <v-row>
                <v-col cols="6" sm="">
                  <v-text-field
                    v-model="name"
                    :rules="[v => !!v || 'Field required']"
                    label="Name"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="">
                  <v-text-field
                    v-model="barcode"
                    :rules="[v => !!v || 'Field required']"
                    label="Barcode"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="auto" align-self="center">
                  <v-btn color="primary" @click="addCard">Toevoegen</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-divider class="hidden-sm-and-down" vertical></v-divider>
          <v-col>
            <div class="display-1">Koppel andere kaarten</div>
            <div class="font-weight-light">
              Je kunt barcodes van andere spaarkaarten koppelen met je Kuzee
              Kuzee kaart.
            </div>
            <div class="font-weight-light">
              Door het tonen van de andere kaart bij Kuzee kun je dan ook Kuzee
              sparen.
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PairCardsDialog",
  props: ["value"],
  data() {
    return {
      name: "",
      barcode: "",
      cards: []
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    addCard() {
      if (this.$refs.addcardform.validate()) {
        this.cards.push({ name: this.name, barcode: this.barcode });
        this.$refs.addcardform.reset();
      }
    },
    deleteCard(index) {
      this.cards.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
